import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import { GetStatusTypesParams, GetStatusTypesResponse } from './types/status-type'

type ApiGetStatusTypesResponse = Promise<AxiosResponse<GetStatusTypesResponse>>

export function getStatusTypes(params: GetStatusTypesParams): ApiGetStatusTypesResponse {
    return http.get('/dispatcher/api/status-type', { params })
}

export default {
    getStatusTypes,
}
